import { ThemingProps } from '@chakra-ui/react';
import React, { ReactNode } from 'react';

import {
  CmButton,
  CmModal,
  CmModalBody,
  CmModalFooter,
} from '@/components/uiParts';

type Props = {
  name: string;
  amendment?: ReactNode;
  size?: ThemingProps<'Modal'>['size'];
  handleClick: () => void;
  isOpen: boolean;
  onClose: () => void;
};

export const CmDeleteConfirmModal: React.FC<Props> = ({
  name,
  amendment,
  size = 'lg',
  handleClick,
  isOpen,
  onClose,
}) => {
  return (
    <CmModal
      title={`${name}を削除する`}
      isCentered
      {...{ isOpen, onClose, size }}
    >
      <CmModalBody>
        <p>
          この{name}を削除しますか？
          <br />
          削除後は元に戻すことはできません。
        </p>
        {amendment}
      </CmModalBody>
      <CmModalFooter>
        {/*
         // @ts-ignore TS2590 */}
        <CmButton colorScheme="red" onClick={handleClick}>
          削除
        </CmButton>
        <CmButton variant="outline" ml="5" onClick={onClose}>
          戻る
        </CmButton>
      </CmModalFooter>
    </CmModal>
  );
};
